/* ============================================================
   DX Landing Page — Interactions
   ============================================================ */

(function () {

  // --- Section entrance animations ---
  var animateEls = document.querySelectorAll('.page-dx-landing .dx-animate');
  if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined' && animateEls.length) {
    gsap.utils.toArray(animateEls).forEach(function (el) {
      gsap.fromTo(el,
        { opacity: 0, y: 24 },
        {
          opacity: 1, y: 0,
          duration: 0.8,
          ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 85%' }
        }
      );
    });
  } else {
    animateEls.forEach(function (el) { el.classList.add('visible'); });
  }

  // --- Progress bar GSAP animation ---
  if (!customElements.get('dx-progress-bar')) {
    class DxProgressBar extends HTMLElement {
      connectedCallback() {
        var fill = this.querySelector('.dx-hero__progress-fill');
        if (!fill) return;
        var target = fill.dataset.target;
        if (!target) return;

        if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
          fill.style.width = '0%';
          gsap.to(fill, {
            width: target,
            duration: 1.5,
            ease: 'power3.out',
            scrollTrigger: { trigger: this, start: 'top 85%' }
          });
        }
      }
    }
    customElements.define('dx-progress-bar', DxProgressBar);
  }

  // --- Sticky mobile CTA ---
  var stickyCta = document.querySelector('.page-dx-landing .dx-sticky-cta');
  var heroSection = document.querySelector('.page-dx-landing .dx-hero');
  if (stickyCta && heroSection) {
    if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
      gsap.set(stickyCta, { yPercent: 100 });
      ScrollTrigger.create({
        trigger: heroSection,
        start: 'bottom top',
        onEnter: function () { gsap.to(stickyCta, { yPercent: 0, duration: 0.3 }); },
        onLeaveBack: function () { gsap.to(stickyCta, { yPercent: 100, duration: 0.3 }); }
      });
    } else if ('IntersectionObserver' in window) {
      var heroObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyCta.classList.toggle('visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      heroObserver.observe(heroSection);
    }
  }

  // --- Smooth scroll to anchor ---
  document.querySelectorAll('[data-scroll-to]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  // --- Reserve modal ---
  if (!customElements.get('dx-reserve-modal')) {
    class DxReserveModal extends HTMLElement {
      connectedCallback() {
        var modal = this;
        var overlay = modal.querySelector('.dx-modal__overlay');
        var closeBtn = modal.querySelector('.dx-modal__close');

        function open(e) {
          if (e) e.preventDefault();
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          var firstInput = modal.querySelector('input[type="email"]');
          if (firstInput) setTimeout(function () { firstInput.focus(); }, 100);
        }
        function close() {
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }

        if (overlay) overlay.addEventListener('click', close);
        if (closeBtn) closeBtn.addEventListener('click', close);
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
        });

        // Wire up all trigger buttons
        document.querySelectorAll('[data-reserve-trigger]').forEach(function (btn) {
          btn.addEventListener('click', open);
        });

        // Auto-open if form has feedback (page reloaded after submission)
        if (modal.querySelector('.dx-modal__alert')) {
          open();
        }
      }
    }
    customElements.define('dx-reserve-modal', DxReserveModal);
  }

})();
